import { useEffect, useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { routes } from "./config";
import { usePageTitleStore } from "entities/pageTitle";

export const TitleSync = () => {
    const location = useLocation();
    const { setRouteTitle } = usePageTitleStore();

    const routeTitle = useMemo(() => {
        for (const r of routes) {
            const m = matchPath({ path: r.path, end: true }, location.pathname);
            if (m) {
                if (typeof r.title === "function") {
                    return r.title((m.params ?? {}) as Record<string, string>);
                }
                return r.title;
            }
        }
        return "";
    }, [location.pathname]);

    useEffect(() => {
        setRouteTitle(routeTitle);
    }, [routeTitle, setRouteTitle]);

    const fullTitle = usePageTitleStore((s) => s.getFullTitle());
    const getDocumentTitle = usePageTitleStore((s) => s.getDocumentTitle);

    useEffect(() => {
        document.title = getDocumentTitle();
    }, [fullTitle, getDocumentTitle]);
    return null;
};
